import { observable } from 'mobx';

export type ArrangerMemoResponseArgs = {
  id: number;
  memo: string;
};

export type ArrangerMemoArgs = {
  id: number;
  memo: string;
};

export const convertArrangerMemoResponseToArgs = (response: ArrangerMemoResponseArgs) => {
  const args: ArrangerMemoArgs = {
    id: response.id,
    memo: response.memo
  };
  return args;
};

export default class ArrangerMemo {
  @observable id: number;
  @observable memo: string;

  constructor(args: ArrangerMemoArgs) {
    this.id = args.id;
    this.memo = args.memo;
  }
}
